import { registerSW } from 'virtual:pwa-register'

// autoUpdate: il SW si aggiorna in background; quando c'è una nuova
// versione la attiviamo subito (l'app verrà ricaricata al prossimo
// refresh della pagina). Mostriamo un piccolo banner se c'è un update
// pronto, in modo che l'utente sappia che può ricaricare.
let updateBanner: HTMLDivElement | null = null

function showUpdateBanner(onUpdate: () => void) {
  if (updateBanner) return
  const div = document.createElement('div')
  div.className = 'pwa-update-banner'
  div.innerHTML = `
    <span>Nuova versione disponibile</span>
    <button type="button">Aggiorna</button>
  `
  div.querySelector('button')?.addEventListener('click', onUpdate)
  document.body.appendChild(div)
  updateBanner = div
}

function showOfflineReady() {
  const div = document.createElement('div')
  div.className = 'pwa-update-banner pwa-offline-ready'
  div.textContent = 'App pronta per uso offline'
  document.body.appendChild(div)
  setTimeout(() => div.remove(), 3500)
}

export function registerServiceWorker() {
  const updateSW = registerSW({
    onNeedRefresh() {
      showUpdateBanner(() => updateSW(true))
    },
    onOfflineReady() {
      showOfflineReady()
    },
  })
}
